import { createAction, props } from '@ngrx/store';
import {
  IReportColumnGroupConfiguration,
  IReportConfigurationModel,
  IReportNameConfiguration,
  IReportTabsConfiguration
} from '../models/report-configuration.model';

export const GetReportConfigurations = createAction('[Settings Reports] Get report configurations');
export const GetReportConfigurationsSuccess = createAction(
  '[Settings Reports] Get report configurations success',
  props<{ configurations: IReportConfigurationModel }>()
);
export const GetReportConfigurationsFailed = createAction(
  '[Settings Reports] Get report configurations failed',
  props<{ error: Error }>()
);

export const SaveReportNameConfiguration = createAction(
  '[Settings Reports] Save report name configuration',
  props<{ name: string; configurations: IReportNameConfiguration; reset?: boolean }>()
);
export const SaveReportNameConfigurationSuccess = createAction(
  '[Settings Reports] Save report name configuration success',
  props<{ name: string; configurations: IReportNameConfiguration }>()
);
export const SaveReportNameConfigurationFailed = createAction(
  '[Settings Reports] Save report name configuration failed',
  props<{ error: Error }>()
);

export const SaveReportTabsConfiguration = createAction(
  '[Settings Reports] Save report tabs configuration',
  props<{ name: string; configurations: IReportTabsConfiguration[]; reset?: boolean }>()
);
export const SaveReportTabsConfigurationSuccess = createAction(
  '[Settings Reports] Save report tabs configuration success',
  props<{ name: string; configurations: IReportTabsConfiguration[] }>()
);
export const SaveReportTabsConfigurationFailed = createAction(
  '[Settings Reports] Save report tabs configuration failed',
  props<{ error: Error }>()
);

export const SaveReportColumnGroupsConfiguration = createAction(
  '[Settings Reports] Save report column groups configuration',
  props<{ name: string; configurations: IReportColumnGroupConfiguration[]; reset?: boolean }>()
);
export const SaveReportColumnGroupsConfigurationSuccess = createAction(
  '[Settings Reports] Save report column groups configuration success',
  props<{ name: string; configurations: IReportColumnGroupConfiguration[] }>()
);
export const SaveReportColumnGroupsConfigurationFailed = createAction(
  '[Settings Reports] Save report column groups configuration failed',
  props<{ error: Error }>()
);
